import { render } from "./LegacyView.vue?vue&type=template&id=48b95df3&scoped=true"
import script from "./LegacyView.vue?vue&type=script&lang=js"
export * from "./LegacyView.vue?vue&type=script&lang=js"

import "./LegacyView.vue?vue&type=style&index=0&id=48b95df3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b95df3"]])

export default __exports__